<template>
  <div class="main_right ammeter-add">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">电表名称：</span>
        </div>
        <el-input v-model="deviceName" size="small" style="width: 280px" />
        <span v-html="deviceNameVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">电表编号：</span>
        </div>
        <el-input v-model="code" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">电表类型：</span>
        </div>
        <el-select v-model="meterDeviceType" size="small" style="width: 280px">
          <el-option v-for="item in meterDeviceTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">电表厂家：</span>
        </div>
        <el-select v-model="deviceManufacturerCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">电表型号：</span>
        </div>
        <el-select v-model="deviceModelCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceModelNameList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
<!--          <b class="red">*</b>-->
          <span class="line-text">电表所属集中器：</span>
        </div>
        <el-select v-model="electricControlDeviceCode" size="small" style="width: 280px">
          <el-option v-for="item in electricList" :key="item.deviceCode"
                     :label="item.name" :value="item.deviceCode">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">互感器配置：</span>
        </div>
        <el-switch
          v-model="mutualInductorState"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </div>

      <div class="form-line" v-if="mutualInductorState">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">互感器倍率：</span>
        </div>
        <el-input-number v-model="powerRate" controls-position="right" size="small" style="width: 280px" :min="1" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">电表级别：</span>
        </div>
        <el-select v-model="level" size="small" style="width: 280px">
          <el-option v-for="item in levelList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="level !== 1">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">上级电表：</span>
        </div>
        <el-select v-model="parentDeviceCode" filterable remote reserve-keyword placeholder="请输入关键词" size="small" style="width: 280px" :remote-method="selectElectricMeterParent">
          <el-option
            v-for="item in parentDeviceList"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">电表所在房间：</span>
        </div>
        <input-tree :fetch="fetchDetail" :showCheckBox="false" @chooseLine="getRoomList" :theValue="roomCode" :theName="buildingRoomName" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">场景：</span>
        </div>
        <el-select v-model="scene" size="small" style="width: 280px">
          <el-option v-for="item in sceneList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line electricity">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">初始电量：</span>
        </div>
        <el-input v-model="electricity" type="number" size="small" style="width: 280px" @blur="electricityBlur">
          <template slot="append">kW·h</template>
        </el-input>
        <span style="display: block;width: 400px;">初始电量为该电表新接入系统的初始度数，该度数作为后续用电的起始值，首次用电值=首次电表读数-该初始读数。一经添加无法修改，请仔细核对。</span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">数据上报类型：</span>
        </div>
        <el-select v-model="useType" size="small" style="width: 280px">
          <el-option v-for="item in useTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">计费系数：</span>
        </div>
        <el-input v-model="billingFactor" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">欠费是否关闸：</span>
        </div>
        <el-switch
          v-model="breaker"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">设备位置：</span>
        </div>
        <el-input v-model="location" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="memo" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">责任人：</span>
        </div>
        <el-select v-model="responsiblePersonCode"
                   filterable
                   remote
                   clearable
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-confirm-next @confirm="addNext" value="添加下一项" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/ElectronicManagement'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import {treeApi} from '../../api/ElectronicTreeApi'
  // let a = document.getElementsByClassName()

  export default {
    components: {
      ButtonConfirmNext,
      ButtonConfirm,
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'ammeter-add',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧用电',
            name: 'electronic-over-view'
          }, {
            value: '电表管理'
          }],
        },
        mainTitle: '添加电表',
        subheading: '',
        deviceName: '',
        code: '',
        deviceNameVer: '<span>不超过32个字</span>',
        deviceManufacturerCode: '华立',
        deviceManufacturerList: [
          {
            name: '华立',
            code: '华立'
          }
        ],
        deviceModelCode: 'DDS28',
        deviceModelNameList: [
          {
            name: 'DDS28',
            code: 'DDS28'
          }
        ],
        meterDeviceType: '单相',
        meterDeviceTypeList: [
          {
            name: '单相',
            code: '单相'
          }, {
            name: '三相',
            code: '三相'
          }
        ],
        electricControlDeviceCode: '',
        electricList: [],
        responsiblePersonCode: '',
        responsiblePersonList: [],
        responsiblePersonVer: '<span>电表责任人</span>',
        deviceNameHttp: false,
        deviceCodeHttp: false,
        fetchDetail: null,
        roomCode: '',
        roomName: '',
        buildingName: '',
        buildingCode: '',
        buildingRoomName: '',
        breaker: false,
        whetherToCount: false,
        scene: '',
        sceneList: [],
        useType: '1',
        useTypeList: [
          {
            name: '自动上报',
            code: '1'
          }, {
            name: '扫码上报',
            code: '2'
          }
        ],
        electricity: '0',
        powerBeforeElectricMeter: '',
        billingFactor: '1',
        mutualInductorState: false,
        mutualInductorOnOrOff: '0',
        powerRate: 1,
        location: '',
        memo: '',

        level: 1,
        levelList: [
          {
            name: '一级',
            code: 1
          }, {
            name: '二级',
            code: 2
          }, {
            name: '三级',
            code: 3
          }, {
            name: '四级',
            code: 4
          }, {
            name: '五级',
            code: 5
          }
        ],
        parentDeviceCode: '',
        parentDeviceName: '',
        parentDeviceList: [],
      }
    },
    created () {
      // this.getAlldeviceManufacturer()
      // this.getAllDeviceType()
      // this.getResponsiblePersonList()
      this.getElectricSceneList()
      this.getElectricManagerList()
      this.remoteMethod()
      this.fetchDetail = () => {
        let treeList = []
        let yqCode = ''

        return treeApi.getYqInfo()
          .then(yqData => {
            let yqObj = {}
            yqCode = yqData.yqCode
            yqObj._value = yqData.yqCode
            yqObj._label = yqData.yqName
            yqObj.parentCode = '0'
            yqObj.level = 1
            yqObj.code = yqData.yqCode
            treeList.push(yqObj)

            treeApi.getVacancyRoomInfo(this.currentCode)
              .then(roomList => {
                roomList.map(room => {
                  let roomObj = {}
                  roomObj.buildingName = room.buildingName
                  roomObj.buildingCode = room.buildingCode
                  roomObj._value = room.code
                  roomObj._label = room.roomNumber
                  roomObj.parentCode = room.floorCode
                  roomObj.level = 4
                  roomObj.code = room.code
                  roomObj.roomArea = room.roomArea
                  roomObj.roomRent = room.roomRent
                  roomObj.roomType = room.roomType
                  treeList.push(roomObj)
                })
              })

            treeApi.getBuildingList()
              .then(buildingList => {
                buildingList.map(v => {
                  let obj = {}
                  obj._value = v.code
                  obj._label = v.name
                  obj.parentCode = yqCode
                  obj.level = 2
                  obj.code = v.code
                  treeList.push(obj)
                  if (v.floors.length > 0) {
                    v.floors.map(floor => {
                      let floorObj = {}
                      floorObj._value = floor.code
                      floorObj._label = floor.name
                      floorObj.parentCode = floor.buildingCode
                      floorObj.level = 3
                      floorObj.code = floor.code
                      treeList.push(floorObj)
                    })
                  }
                })

              })
            return treeList
          })
      }
    },
    methods: {
      selectElectricMeterParent (query) {
        this.getElectricMeterParentList(query)
      },
      // 获取父级电表
      getElectricMeterParentList (query) {
        if (this.level !== 1) {
          this.$axios.post(api.getElectricMeterParentList, {
            level: this.level,
            searchKey: query || ''
          })
            .then(res => {
              let list = res.data.data
              this.parentDeviceList = list
            })
            .catch(errorHandler('获取父级电表失败'))
        }
      },
      // 获取场景列表
      getElectricSceneList () {
        this.$axios.post(api.getElectricSceneList, {})
          .then(res => {
            let list = res.data.data
            this.sceneList = list
          })
          .catch(errorHandler('获取场景列表失败'))
      },
      // 获取集中器列表
      getElectricManagerList (searchKey) {
        this.$axios.post(api.getElectricManagerList, {})
          .then(res => {
            let list = res.data.data
            this.electricList = list
          })
          .catch(errorHandler('获取集中器列表失败'))
      },
      // 获取责任人列表
      getResponsiblePersonList (searchKey) {
        this.$axios.post(`${api.getResponsiblePersonList}?searchKey=${searchKey || ''}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let list = res.data.data
              list.forEach(it => {
                it._value = it.code
                it._label = `${it.name} / ${it.phone}`
              })
              this.responsiblePersonList = list
            }
          })
          .catch(errorHandler('获取责任人列表失败'))
      },

      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },
      getRoomList (data) {
        if (data) {
          this.roomCode = data._value
          this.roomName = data._label
          this.buildingName = data.buildingName
          this.buildingCode = data.buildingCode
          this.buildingRoomName = `${data.buildingName}${data._label}`
        } else {
          this.roomCode = ''
          this.roomName = ''
          this.buildingName = ''
          this.buildingCode = ''
          this.buildingRoomName = ''
        }
      },
      electricityBlur () {
        if (this.electricity === '') {
          this.electricity = '0'
        }
        this.$confirm('初始电量为该电表新接入系统的初始度数，该度数作为后续用电的起始值，首次用电值=首次电表读数-该初始读数。一经添加无法修改，请仔细核对。', '温馨提示', {
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: '我知道了'
        })
      },
      addNext () {
        if(this.billingFactor==''){
        }else{
          if(!isNumber(this.billingFactor)||this.billingFactor<=0){
            nError("计费系数请输入正确的数字")
            return false
          }
        }
        if (!this.deviceName) {
          this.deviceNameVer = '<span style="color: red;">请输入电表名称</span>'
          return false
        }
        if (!this.code) {
          nError('请输入电表编号')
          return false
        }
        if (!this.scene) {
          nError('请选择场景')
          return false
        }
        if (this.level !== 1 && !this.parentDeviceCode) {
          nError('请选择上级电表')
          return false
        }
        // if (!this.responsiblePersonCode) {
        //   this.responsiblePersonVer = '<span style="color: red;">请选择电表责任人</span>'
        //   return false
        // }
        if (!this.deviceNameHttp) {
          return false
        } else {
          this.deviceNameVer = '<span>不超过32个字</span>'
        }
        let obj = {
          name: this.deviceName,
          code: this.code,
          meterDeviceType: this.meterDeviceType,
          meterDeviceManufacturerCode: this.deviceManufacturerCode,
          meterDeviceManufacturerName: '',
          meterDeviceModelCode: this.deviceModelCode,
          meterDeviceModelName: '',
          electricControlDeviceCode: this.electricControlDeviceCode,
          electricControlDeviceName: '',
          roomCode: this.roomCode,
          roomNumber: this.roomName,
          buildingCode: this.buildingCode,
          buildingName: this.buildingName,
          sceneCode: this.scene,
          sceneName: '',
          useType: this.useType,
          electricity: this.electricity,
          billingFactor: this.billingFactor,
          // responsiblePersonCode: this.responsiblePersonCode,
          // responsiblePersonName: '',
          // responsiblePersonPhone: '',
          autoOff: '0',
          mutualInductorOnOrOff: this.mutualInductorOnOrOff,
          powerRate: this.powerRate,
          memo: this.memo,
          location: this.location,

          level: this.level,
          parentDeviceCode: this.parentDeviceCode,
          parentDeviceName: this.parentDeviceName,
        }
        if (this.breaker) {
          obj.autoOff = '1'
        } else {
          obj.autoOff = '0'
        }
        this.parentDeviceList.map(v => {
          if (v.code === this.parentDeviceCode) {
            obj.parentDeviceName = v.name
          }
        })
        this.sceneList.map(v => {
          if (v.code === this.scene) {
            obj.sceneName = v.name
          }
        })
        this.electricList.map(v => {
          if (v.deviceCode === this.electricControlDeviceCode) {
            obj.electricControlDeviceName = v.name
          }
        })
        this.deviceManufacturerList.map(v => {
          if (v.code === this.deviceManufacturerCode) {
            obj.meterDeviceManufacturerName = v.name
          }
        })
        this.deviceModelNameList.map(v => {
          if (v.code === this.deviceModelCode) {
            obj.meterDeviceModelName = v.name
          }
        })
        this.responsiblePersonList.map(v => {
          if (v.code === this.responsiblePersonCode) {
            obj.personName = v.name
            obj.personCode = v.code
            obj.responsiblePersonPhone = v.phone
          }
        })
        this.$axios.post(api.addElectricMeter, obj)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.deviceName = ''
              this.code = ''
              this.memo = ''
              // this.responsiblePersonCode = ''
            }
          })
          .catch(errorHandler('添加电表失败'))
      },
      add () {
        if(this.billingFactor==''){
        }else{
          if(!isNumber(this.billingFactor)||this.billingFactor<=0){
            nError("计费系数请输入正确的数字")
            return false
          }
        }
        if (!this.deviceName) {
          this.deviceNameVer = '<span style="color: red;">请输入电表名称</span>'
          return false
        }
        if (!this.code) {
          nError('请输入电表编号')
          return false
        }
        if (!this.scene) {
          nError('请选择场景')
          return false
        }
        if (this.level !== 1 && !this.parentDeviceCode) {
          nError('请选择上级电表')
          return false
        }
        // if (!this.responsiblePersonCode) {
        //   this.responsiblePersonVer = '<span style="color: red;">请选择电表责任人</span>'
        //   return false
        // }
        if (!this.deviceNameHttp) {
          return false
        } else {
          this.deviceNameVer = '<span>不超过32个字</span>'
        }
        let obj = {
          name: this.deviceName,
          code: this.code,
          meterDeviceType: this.meterDeviceType,
          meterDeviceManufacturerCode: this.deviceManufacturerCode,
          meterDeviceManufacturerName: '',
          meterDeviceModelCode: this.deviceModelCode,
          meterDeviceModelName: '',
          electricControlDeviceCode: this.electricControlDeviceCode,
          electricControlDeviceName: '',
          roomCode: this.roomCode,
          roomNumber: this.roomName,
          buildingCode: this.buildingCode,
          buildingName: this.buildingName,
          sceneCode: this.scene,
          sceneName: '',
          useType: this.useType,
          electricity: this.electricity,
          billingFactor: this.billingFactor,
          // responsiblePersonCode: this.responsiblePersonCode,
          // responsiblePersonName: '',
          // responsiblePersonPhone: '',
          autoOff: '0',
          mutualInductorOnOrOff: this.mutualInductorOnOrOff,
          powerRate: this.powerRate,
          memo: this.memo,
          location: this.location,

          level: this.level,
          parentDeviceCode: this.parentDeviceCode,
          parentDeviceName: this.parentDeviceName,
        }
        if (this.breaker) {
          obj.autoOff = '1'
        } else {
          obj.autoOff = '0'
        }
        this.parentDeviceList.map(v => {
          if (v.code === this.parentDeviceCode) {
            obj.parentDeviceName = v.name
          }
        })
        this.sceneList.map(v => {
          if (v.code === this.scene) {
            obj.sceneName = v.name
          }
        })
        this.electricList.map(v => {
          if (v.deviceCode === this.electricControlDeviceCode) {
            obj.electricControlDeviceName = v.name
          }
        })
        this.deviceManufacturerList.map(v => {
          if (v.code === this.deviceManufacturerCode) {
            obj.meterDeviceManufacturerName = v.name
          }
        })
        this.deviceModelNameList.map(v => {
          if (v.code === this.deviceModelCode) {
            obj.meterDeviceModelName = v.name
          }
        })
        this.responsiblePersonList.map(v => {
          if (v.code === this.responsiblePersonCode) {
            obj.personName = v.name
            obj.personCode = v.code
            obj.responsiblePersonPhone = v.phone
          }
        })
        this.$axios.post(api.addElectricMeter, obj)
          .then(res => {
            nSuccess('添加成功')
            this.strategyCenter()
          })
          .catch(errorHandler('添加电表失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'ammeter-management'
        })
      }
    },
    watch: {
      deviceName (v) {
        let ptn = pattern.basicAndCN.test(v)
        if (!ptn) {
          this.deviceNameVer = '<span style="color: red;">只允许输入中文，字母，数字，下划线</span>'
          this.deviceNameHttp = false
        } else {
          this.deviceNameVer = '<span>不超过32个字</span>'
          this.deviceNameHttp = true
        }
      },
      meterDeviceType (val) {
        if (val === '单相') {
          this.deviceModelCode = 'DDS28'
          this.deviceModelNameList = [
            {
              name: 'DDS28',
              code: 'DDS28'
            }
          ]
        } else if (val === '三相') {
          this.deviceModelCode = 'DTS541'
          this.deviceModelNameList = [
            {
              name: 'DTS541',
              code: 'DTS541'
            }
          ]
        }
      },
      mutualInductorState () {
        if (this.mutualInductorState) {
          this.mutualInductorOnOrOff = '1'
        } else {
          this.mutualInductorOnOrOff = '0'
          this.powerRate = 1
        }
      },
      level () {
        this.getElectricMeterParentList()
      }
    }
  }
  function isNumber(val) {
    let regPos = /^\d+(\.\d+)?$/; //非负浮点数
    let regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if(regPos.test(val) || regNeg.test(val)) {
      return true;
    } else {
      return false;
    }
  }
</script>



<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 15px 0;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 160px;
    text-align: right;
  }
  .form-btn-box {
    width: 605px;
    padding: 0 162px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .ammeter-add {
    .electricity {
      .el-input__inner {
        padding: 0 0 0 15px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/ElectronicManagement/AmmeterManagement/AmmeterAdd.vue